import { styled } from 'styled-components';

const Box = styled.div`
  background: white;
  border-radius: 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
`;

export default Box;
